import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  Stack,
  Typography
} from "@mui/material";

const Login = ({ show, handleClose, handleAuth, showAlert, alert }) => {
  const [isRegistering, setIsRegistering] = useState(false);

  const [formData, setFormData] = useState({
    phone: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const [loginData, setLoginData] = useState({
    phone: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLoginChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleSubmitRegister = (e) => {
    e.preventDefault();
    handleAuth("register", formData);
  };

  const handleSubmitLogin = (e) => {
    e.preventDefault();
    handleAuth("login", loginData);
  };

  return (
    <Dialog open={show} onClose={handleClose} fullWidth maxWidth="xs">

      <DialogTitle>
        {isRegistering ? "Регистрация" : "Вход"}
      </DialogTitle>

      <DialogContent>

        {showAlert && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {alert.message}
          </Alert>
        )}

        {isRegistering ? (
          <Stack spacing={2} component="form" onSubmit={handleSubmitRegister}>

            <TextField
              label="Телефон"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              fullWidth
              required
            />

            <TextField
              label="Имя"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              fullWidth
              required
            />

            <TextField
              label="Фамилия"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              fullWidth
              required
            />

            <TextField
              label="Email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              placeholder="example@email.com"
            />

            <TextField
              label="Пароль"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              fullWidth
              required
            />

            <Button type="submit" variant="contained">
              Зарегистрироваться
            </Button>

            <Typography
              variant="body2"
              sx={{ cursor: "pointer", textAlign: "center", color: "#6b7280" }}
              onClick={() => setIsRegistering(false)}
            >
              Уже есть аккаунт?{" "}
              <Typography
                component="span"
                sx={{
                  color: "#6366f1",
                  fontWeight: 600,
                  "&:hover": { textDecoration: "underline", color: "#4f46e5" },
                }}
              >
                Войти
              </Typography>
            </Typography>

          </Stack>
        ) : (
          <Stack spacing={2} component="form" onSubmit={handleSubmitLogin}>

            <TextField
              label="Телефон"
              name="phone"
              value={loginData.phone}
              onChange={handleLoginChange}
              fullWidth
              required
            />

            <TextField
              label="Пароль"
              type="password"
              name="password"
              value={loginData.password}
              onChange={handleLoginChange}
              fullWidth
              required
            />

            <Button type="submit" variant="contained">
              Войти
            </Button>

            <Typography
              variant="body2"
              sx={{ cursor: "pointer", textAlign: "center", color: "#6b7280" }}
              onClick={() => setIsRegistering(true)}
            >
              Нет аккаунта?{" "}
              <Typography
                component="span"
                sx={{
                  color: "#6366f1",
                  fontWeight: 600,
                  "&:hover": { textDecoration: "underline", color: "#4f46e5" },
                }}
              >
                Зарегистрироваться
              </Typography>
            </Typography>

          </Stack>
        )}

      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Закрыть</Button>
      </DialogActions>

    </Dialog>
  );
};

export default Login;